import { PayloadAction } from '@reduxjs/toolkit';
import { Event, EventType, ScheduleState } from '../state';

export const openEventUploadDialog = (state: ScheduleState, action: PayloadAction<Event>) => {
    state.dialog.isReference = false;
    state.dialog.data = action.payload;
}

export const openEventReferenceDialog = (state: ScheduleState, action: PayloadAction<Event>) => {
    state.dialog.isReference = true;
    state.dialog.data = action.payload;
}

export const closeEventDialog = (state: ScheduleState, _: PayloadAction) => {
    state.dialog.data = null;
}

export const changeEventDialogDataType = (state: ScheduleState, action: PayloadAction<EventType>) => {
    if (state.dialog.data) {
        state.dialog.data.type = action.payload;

        switch (action.payload) {
            case 'AM練習':
                state.dialog.data.startTime = '09:00';
                state.dialog.data.endTime = '13:00';
                break;
            case 'PM練習':
                state.dialog.data.startTime = '13:00';
                state.dialog.data.endTime = '17:00';
                break;
        }
    }
}

export const changeEventDialogDataStartTime = (state: ScheduleState, action: PayloadAction<string>) => {
    if (state.dialog.data) {
        state.dialog.data.startTime = action.payload;
    }
}

export const changeEventDialogDataEndTime = (state: ScheduleState, action: PayloadAction<string>) => {
    if (state.dialog.data) {
        state.dialog.data.endTime = action.payload;
    }
}

export const changeEventDialogDataPlace = (state: ScheduleState, action: PayloadAction<string>) => {
    if (state.dialog.data) {
        state.dialog.data.place = action.payload;
    }
}

export const changeEventDialogDataDescription = (state: ScheduleState, action: PayloadAction<string>) => {
    if (state.dialog.data) {
        state.dialog.data.description = action.payload;
    }
}
